module.exports = __webpack_public_path__ + "static/media/CSU-Signature-Stacked-357-617.327dfee4.svg";